import type { PartnerCityId, PricingPlanCategory } from '../../content';
import type { AvailabilityResult } from '../types';

const NEIGHBOURHOOD_PATTERNS: { pattern: RegExp; id: string; label: string; cityId: PartnerCityId }[] = [
  { pattern: /wynwood/i, id: 'wynwood', label: 'Wynwood', cityId: 'miami' },
  { pattern: /brickell/i, id: 'brickell', label: 'Brickell', cityId: 'miami' },
  {
    pattern: /south beach|miami beach/i,
    id: 'south-beach',
    label: 'South Beach',
    cityId: 'miami',
  },
  { pattern: /gràcia|gracia/i, id: 'gracia', label: 'Gràcia', cityId: 'barcelona' },
  { pattern: /eixample/i, id: 'eixample', label: 'Eixample', cityId: 'barcelona' },
  { pattern: /born|la ribera/i, id: 'born', label: 'El Born', cityId: 'barcelona' },
  { pattern: /malasaña|malasana/i, id: 'malasana', label: 'Malasaña', cityId: 'madrid' },
  { pattern: /chueca/i, id: 'chueca', label: 'Chueca', cityId: 'madrid' },
  { pattern: /salamanca/i, id: 'salamanca', label: 'Salamanca', cityId: 'madrid' },
];

const SLOT_DATA: Record<string, { occupied: number; max: number }> = {
  'miami|wynwood|food': { occupied: 1, max: 3 },
  'miami|wynwood|wellness': { occupied: 2, max: 3 },
  'miami|brickell|food': { occupied: 2, max: 3 },
  'miami|brickell|wellness': { occupied: 1, max: 3 },
  'miami|south-beach|food': { occupied: 1, max: 3 },
  'miami|south-beach|wellness': { occupied: 2, max: 3 },
  'barcelona|gracia|food': { occupied: 2, max: 3 },
  'barcelona|gracia|wellness': { occupied: 3, max: 3 },
  'barcelona|eixample|food': { occupied: 1, max: 3 },
  'barcelona|eixample|wellness': { occupied: 2, max: 3 },
  'barcelona|born|food': { occupied: 0, max: 3 },
  'barcelona|born|wellness': { occupied: 1, max: 3 },
  'madrid|malasana|food': { occupied: 2, max: 3 },
  'madrid|malasana|wellness': { occupied: 1, max: 3 },
  'madrid|chueca|food': { occupied: 3, max: 3 },
  'madrid|chueca|wellness': { occupied: 2, max: 3 },
  'madrid|salamanca|food': { occupied: 1, max: 3 },
  'madrid|salamanca|wellness': { occupied: 0, max: 3 },
};

const DEFAULT_NEIGHBOURHOOD: Record<PartnerCityId, { id: string; label: string }> = {
  miami: { id: 'wynwood', label: 'Wynwood' },
  barcelona: { id: 'eixample', label: 'Eixample' },
  madrid: { id: 'malasana', label: 'Malasaña' },
};

export function deriveNeighbourhoodFromAddress(
  address: string,
  cityId: PartnerCityId,
): { id: string; label: string } {
  const match = NEIGHBOURHOOD_PATTERNS.find(
    (entry) => entry.cityId === cityId && entry.pattern.test(address),
  );
  if (match) {
    return { id: match.id, label: match.label };
  }
  return DEFAULT_NEIGHBOURHOOD[cityId];
}

export function checkAvailability(
  cityId: PartnerCityId,
  neighbourhoodId: string,
  neighbourhoodLabel: string,
  category: PricingPlanCategory,
): AvailabilityResult {
  const key = `${cityId}|${neighbourhoodId}|${category}`;
  const slots = SLOT_DATA[key] ?? { occupied: 1, max: 3 };

  return {
    neighbourhood: neighbourhoodId,
    neighbourhoodLabel,
    category,
    occupied: slots.occupied,
    maxSlots: slots.max,
    available: slots.occupied < slots.max,
  };
}
